
import React from 'react';
import AhavexerLoginForm from './AhavexerLoginForm';
import CustomerLoginForm from './CustomerLoginForm';

interface LoginFormProps {
  userType: 'ahavexer' | 'customer';
  onSuccess?: () => void;
}

const LoginForm: React.FC<LoginFormProps> = ({ userType, onSuccess }) => {
  return userType === 'ahavexer' 
    ? <AhavexerLoginForm onSuccess={onSuccess} />
    : <CustomerLoginForm onSuccess={onSuccess} />;
};

export default LoginForm;
